import { ResidentialService } from 'src/app/questionarie-signup/questionnaire-residential/residential.service';
import { RecommendationService } from 'src/app/questionarie-signup/questionnaire-residential/recommendation/recommendation.service';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { _ } from 'underscore';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserSettingsService } from 'src/app/user-settings/user-settings.service';
import { Subject } from 'rxjs/internal/Subject';

@Component({
  selector: 'app-pre-congrats',
  templateUrl: './pre-congrats.component.html',
  styleUrls: ['./pre-congrats.component.css'],
})
export class PreCongratsComponent implements OnInit {
  hgPrecong;
  isChecked = true;
  ans_in_precong;
  user_bot = false;
  elem1;
  first_name;
  last_name;
  phone_num;
  phone_num1;
  dob;
  email_address;
  confirm_email_address;
  hearusOption;
  language = 'Language Preference';
  represnt;
  promo_code;
  ssn = '123-45-6789';
  license;
  invoices = ['Paper', 'Paperless'];
  invoice;
  select;
  showHear = false;
  showSSN = false;
  state = 'Texas';
  elem2;
  enrollNotifyObj;
  queryObj = {
    _id: '',
    esiid: '',
    hg_orders_id: '',
    hg_accountId: '',
  };
  display = 'none';
  updateObj = {};
  userResponses;
  deviceWidth;
  esiid_value: any;
  disableBtn = true;
  ngClass = false;
  // For backend url
  url = environment.api_url;
  selectedProduct;
  providerContact;
  accountNumber;
  customerId;
  productName;
  postResultResponseFlag = false;
  cleartimer;
  postResponseMessage;
  private unsubscribe = new Subject<void>();
  postResultText = '0';
  postResultResponseMessage = {
    0: 'While you wait for us to \n process your enrollment...',
    1: 'Your enrollment has been processed. \n Press NEXT to proceed.',
  };
  constructor(
    private residentialService: ResidentialService,
    private userSettingsService: UserSettingsService,
    private recommendationService: RecommendationService,
    private router: Router,
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    private ref: ChangeDetectorRef
  ) {
    // this.getProviderInfo();
    this.hgPrecong = {
      value1: false,
      value2: false,
    };
    this.deviceWidth = this.residentialService.deviceWidth;
  }

  pad(number) {
    return (number < 10 ? '0' : '') + number;
  }

  ngOnInit() {
    this.assignRecommendedSelectedProduct();
    if (this.deviceWidth < 768) {
      this.elem1 = document.getElementById('NoThkyou_mob');
      this.elem2 = document.getElementById('YesInterest_mob');
    } else {
      this.elem1 = document.getElementById('NoThkyou');
      this.elem2 = document.getElementById('YesInterest');
    }
    // Disable the Browser back button in pre-congrats page.
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
    if (!_.isEmpty(this.residentialService.enrollmentPostResult)) {
      this.postResultText = '1';
      this.postResultResponseFlag = true;
    }
    this.postResultText = this.replaceNewLineWithBreak(
      this.postResultResponseMessage[this.postResultText]
    );
  }

  replaceNewLineWithBreak(itemValue: string) {
    return itemValue.replace('\n', '<br>');
  }

  assignRecommendedSelectedProduct() {
    if (_.isEmpty(this.recommendationService.signupProduct)) {
      this.recommendationService.signupProduct = JSON.parse(
        sessionStorage.getItem('signupProduct')
      );
    }
    this.selectedProduct = this.recommendationService.signupProduct;
  }

  getPrecong(event) {
    this.isChecked = event.target.checked;
    const mbNoChck = document.getElementById('mbNo');
    const mbYesChck = document.getElementById('mbyes');
    if (this.isChecked === true) {
      if (event.target.value === 'No, thank you') {
        this.hgPrecong = {
          value1: true,
          value2: false,
        };
        this.elem1.parentElement.classList.add('active-select');
        mbNoChck.classList.add('mbborder');
        if (
          _.contains(this.elem2.parentElement.classList, 'active-select') ||
          mbYesChck.classList.contains('mbborder')
        ) {
          this.elem2.parentElement.classList.remove('active-select');
          mbYesChck.classList.remove('mbborder');
        }
        this.ans_in_precong = event.target.value;
        this.user_bot = true;
      } else if (event.target.value === "Yes, I'm interested!") {
        this.hgPrecong = {
          value1: false,
          value2: true,
        };
        this.elem2.parentElement.classList.add('active-select');
        mbYesChck.classList.add('mbborder');
        if (
          _.contains(this.elem1.parentElement.classList, 'active-select') ||
          mbNoChck.classList.contains('mbborder')
        ) {
          this.elem1.parentElement.classList.remove('active-select');
          mbNoChck.classList.remove('mbborder');
        }
        this.ans_in_precong = event.target.value;
        this.user_bot = true;
      }
    } else {
      this.hgPrecong = {
        value1: false,
        value2: false,
      };
      this.user_bot = false;
      this.elem2.parentElement.classList.remove('active-select');
      this.elem1.parentElement.classList.remove('active-select');
      mbYesChck.classList.remove('mbborder');
      mbNoChck.classList.remove('mbborder');
      // this.save();
    }
  }

  openModal() {
    this.display = 'block';
  }
  // to close the modal
  onCloseHandled() {
    this.display = 'none';
  }

  // navigate to congrats screen
  next() {
    var postresult = JSON.parse(this.residentialService.enrollmentPostResult);
    var webStatus = '';
    var creditCheckResults = '';

    var redirectionPage = '';
    var isSendTextMessage = false;
    var isSendEmail = false;
    var SMSText = '';
    var emailSubject = '';
    var emailTemplateName = '';

    this.openModal();

    if (postresult != undefined && postresult['success'] == true) {
      //Post or Put Response Success = TRUE
      if (postresult['data'].webStatus) {
        webStatus = postresult['data'].webStatus;
        webStatus = webStatus.toUpperCase();
      } else if (postresult['data'].creditCheckResults) {
        creditCheckResults = postresult['data'].creditCheckResults;
        creditCheckResults = creditCheckResults.toUpperCase();
        this.accountNumber = postresult['data'].accountNumber;
      }

      if (
        webStatus === 'COMPLETE_SATISFIED' ||
        creditCheckResults === 'OPENED_WITH_NO_DEPOSIT'
      ) {
        redirectionPage = 'congrats';
        isSendTextMessage = false;
        isSendEmail = false;
      } else if (webStatus === 'COMPLETE_PENDING' || webStatus === 'PENDING') {
        redirectionPage = 'creditcheck-furtheraction';
        isSendTextMessage = false;
        isSendEmail = false;
      } else if (creditCheckResults == 'OPENED_WITH_DEPOSIT') {
        redirectionPage = 'openwithdeposit';
        isSendTextMessage = true;
        isSendEmail = true;
        emailTemplateName = 'residential_openwithdeposit';
        emailSubject =
          'Action Needed // Finish Signing up With' +
          (sessionStorage.getItem('energyProvider')
            ? sessionStorage.getItem('energyProvider')
            : '');
        SMSText =
          'Hey ' +
          (sessionStorage.getItem('enName')
            ? sessionStorage.getItem('enName')
            : '') +
          '!' +
          ' Thx for choosing Honest Gorilla! ' +
          (sessionStorage.getItem('energyProvider')
            ? sessionStorage.getItem('energyProvider')
            : '') +
          ' wants you to post a deposit to get started. Press ' +
          this.providerContact.contact_number +
          ' and finalize your enrollment.';
      } else if (creditCheckResults == 'SERVICE_DENIED') {
        redirectionPage = 'service-denied';
        isSendTextMessage = true;
        isSendEmail = true;
        emailTemplateName = 'residential_postresultFaliedcase';
        emailSubject = 'Can You Confirm Something?';
        SMSText =
          'Hey ' +
          (sessionStorage.getItem('enName')
            ? sessionStorage.getItem('enName')
            : '') +
          '!' +
          ' Thx for choosing Honest Gorilla! You may have placed a freeze on your credit. Pls remove and call ' +
          this.providerContact.contact_number +
          'to finalize your enrollment.';
      } else {
        redirectionPage = 'creditcheck-furtheraction';
        isSendTextMessage = true;
        isSendEmail = true;
        emailSubject = 'Got a Second For a Quick Convo?';
        emailTemplateName = 'residential_postresultFaliedcase2';
        SMSText =
          'Hey! Thx for choosing Honest Gorilla! ' +
          (sessionStorage.getItem('energyProvider')
            ? sessionStorage.getItem('energyProvider')
            : '') +
          ' needs more info from you. Press' +
          this.providerContact.contact_number +
          'to finalize your enrollment.';
      }

      console.log(
        'RedirectionPage:' +
          redirectionPage +
          '; isSendTextMessage: ' +
          isSendTextMessage
      );
    } else if (postresult['Status']) {
      let status = postresult['Status'];
      let message = postresult['Message'];
      if (
        postresult['Status'] &&
        (postresult['Status'] === 'Validation Failed' ||
          postresult['Status'] === 'Deposit Failed')
      ) {
        let postMessageResult = postresult['Message'];
        this.postResponseMessage = postMessageResult;
      } else if (
        status === 'Enrollment has been completed' ||
        status === 'Enrollment has been completed with Pending Status'
      ) {
        redirectionPage = 'congrats';
        isSendTextMessage = false;
        isSendEmail = false;
        sessionStorage.setItem('referenumber', postresult['RefrenceNumber']);
      } else if (
        message === 'Required     Deposit Fields' ||
        message === 'Required Deposite Fields'
      ) {
        redirectionPage = 'depositrequired';
        isSendTextMessage = false;
        isSendEmail = false;
        webStatus = 'PENDING';
      } else if (status === 'CreditCheck Failed') {
        redirectionPage = 'creditcheck-furtheraction';
        isSendTextMessage = false;
        isSendEmail = false;
        webStatus = 'FAILED';
      } else {
        redirectionPage = 'creditcheck-furtheraction';
        isSendTextMessage = false;
        isSendEmail = false;
        webStatus = 'FAILED';
      }
    } else {
      webStatus = 'FAILED';
      //Post or Put Response Success = FALSE
      redirectionPage = 'creditcheck-furtheraction';
      isSendTextMessage = true;
      isSendEmail = true;
      SMSText =
        'Hey! Thx for choosing Honest Gorilla! ' +
        (sessionStorage.getItem('energyProvider')
          ? sessionStorage.getItem('energyProvider')
          : '') +
        ' needs more info from you. Press' +
        this.providerContact.contact_number +
        'to finalize your enrollment.';
      emailSubject = 'Got a Second For a Quick Convo?';
      emailTemplateName = 'residential_postresultFaliedcase2';
    }

    var messageObj = {
      postResultStatus: webStatus ? webStatus : creditCheckResults,
      msg: SMSText,
      phoneno: sessionStorage.getItem('userphone'),
      name: sessionStorage.getItem('enName')
        ? sessionStorage.getItem('enName')
        : '',
      emailId: sessionStorage.getItem('emailId')
        ? sessionStorage.getItem('emailId')
        : '',
      energyProvider: sessionStorage.getItem('energyProvider')
        ? sessionStorage.getItem('energyProvider')
        : '',
      accountNumber: this.accountNumber ? this.accountNumber : '',
      productName: sessionStorage.getItem('signupProduct')
        ? JSON.parse(sessionStorage.getItem('signupProduct')).product_key
        : '',
      isSendTextMessage: isSendTextMessage,
      isSendEmail: isSendEmail,
      emailSubject: emailSubject,
      emailTemplateName: emailTemplateName,
    };

    this.onCloseHandled();

    const hg_accountId = window.location.href.split('/').pop();
    this.router.navigate([redirectionPage, hg_accountId]);

    this.residentialService
      .SendMessagesAfterPostOfEnrollment(messageObj)
      .subscribe((res: any) => {
        console.log('Message Sent successfully: ', res);
      });

    const userObj = {
      hg_accountId: hg_accountId,
      esiid: localStorage.getItem('currentEsiid'),
      emailId: JSON.parse(sessionStorage.getItem('userObj')).emailId,
    };

    // To get the service type values
    var serviceType, startDate, switchType, moveInType, expiredDate;

    const responses = JSON.parse(sessionStorage.getItem('userResponse'));
    this.userResponses = responses.userResponses;
    this.residentialService.userResponse['userResponses'] = this.userResponses;
    if (!_.isEmpty(this.userResponses)) {
      const switchObj = _.findWhere(this.userResponses, {
        res_question_id: '002',
      });
      serviceType = switchObj.fieldValue;
      if (serviceType === 'New Service') {
        // this.startDate = 'Priority Move-In';
        const switchDateObj = _.findWhere(this.userResponses, {
          res_question_id: '007',
        });
        if (!_.isEmpty(switchDateObj)) {
          // console.log.log(switchDateObj);
          moveInType = switchDateObj.startDateType;
          if (
            switchDateObj.startDateType &&
            switchDateObj.startDateType === 'Priority Move-In'
          ) {
            startDate = 'Priority Move-In';
          } else {
            const someDate = new Date();
            const numberOfDaysToAdd = 2;
            someDate.setDate(someDate.getDate() + numberOfDaysToAdd);
            if (new Date(switchDateObj.fieldValue) < someDate) {
              startDate = 'Priority Move-In';
            } else {
              // console.log.log(switchDateObj);
              startDate =
                this.pad(new Date(switchDateObj.fieldValue).getMonth() + 1) +
                '/' +
                new Date(switchDateObj.fieldValue).getDate() +
                '/' +
                new Date(switchDateObj.fieldValue).getFullYear();
            }
          }
        }
        switchType = 'Standard Move-In';
      } else {
        const obj = _.findWhere(this.userResponses, { res_question_id: '004' });
        switchType = obj.fieldValue;
        if (obj.fieldValue === 'Standard Switch') {
          startDate = 'Standard Switch';
        } else {
          const dateObj = _.findWhere(this.userResponses, {
            res_question_id: '005',
          });
          startDate =
            this.pad(new Date(dateObj.fieldValue).getMonth() + 1) +
            '/' +
            new Date(dateObj.fieldValue).getDate() +
            '/' +
            new Date(dateObj.fieldValue).getFullYear();
        }
      }

      // Get the expirationDate
      const expireObj = _.findWhere(this.userResponses, {
        res_question_id: '003',
      });
      if (!_.isEmpty(expireObj) && typeof expireObj.fieldValue !== 'string') {
        const date = JSON.parse(expireObj.fieldValue.date);
        expiredDate =
          this.pad(new Date(date).getMonth() + 1) +
          '/' +
          this.pad(new Date(date).getDate()) +
          '/' +
          new Date(date).getFullYear();
      } else if (
        !_.isEmpty(expireObj) &&
        typeof expireObj.fieldValue === 'string'
      ) {
        expiredDate = expireObj.fieldValue;
      }
    }

    var postStatus, reason;
    let referenumber = '';
    if (
      postresult['Status'] === 'Enrollment has been completed' ||
      postresult['Status'] ===
        'Enrollment has been completed with Pending Status'
    ) {
      postStatus = 'COMPLETED';
      reason = postresult['Message'] ? postresult['Message'] : 'COMPLETED';
      referenumber = postresult['RefrenceNumber'];
    } else if (creditCheckResults === 'OPENED_WITH_DEPOSIT') {
      referenumber = this.accountNumber;
      reason = 'Waiting for Deposit to be made';
      postStatus = 'PENDING';
    }

    if (
      creditCheckResults === 'OPENED_WITH_NO_DEPOSIT' ||
      postresult['Status'] === 'Enrollment has been completed' ||
      postresult['Status'] ===
        'Enrollment has been completed with Pending Status'
    ) {
      postStatus = 'COMPLETED';
    } else if (creditCheckResults == 'SERVICE_DENIED') {
      postStatus = 'FAILED';
      reason = 'Service Denied';
    } else {
      postStatus = 'FAILED';
    }

    const orderDetails = {
      order_no: null,
      hg_accountId: hg_accountId,
      ConfirmationNumber: referenumber ? referenumber : '',
      status: postresult ? postresult['success'] : '',
      isDepositRequired: postresult ? postresult['Message'] : '',
      webStatus: postStatus ? postStatus : '',
      reason: reason ? reason : '',
      creditCheckResults: creditCheckResults,
      customerId: postresult
        ? postresult['data']
          ? postresult['data'].customerId
          : ''
        : '',
      enableSMSForHonest: sessionStorage.getItem('enablesmshonest')
        ? sessionStorage.getItem('enablesmshonest')
        : '',
      enableSMSForChariot: sessionStorage.getItem('enablesmschariot')
        ? sessionStorage.getItem('enablesmschariot')
        : '',
      ratePlanName: sessionStorage.getItem('signupProduct')
        ? JSON.parse(sessionStorage.getItem('signupProduct')).product_key
        : '',
      serviceTypeDetails: {
        serviceType: serviceType,
        switchType: switchType,
        switchDate: startDate,
        moveInType: switchType,
        expiredDate: startDate,
      },
      contactInfo: {
        legalFirstName: JSON.parse(sessionStorage.getItem('userObj')).fName
          ? JSON.parse(sessionStorage.getItem('userObj')).fName
          : this.first_name,
        legalLastName: JSON.parse(sessionStorage.getItem('userObj')).lName
          ? JSON.parse(sessionStorage.getItem('userObj')).lName
          : this.last_name,
        emailId: this.email_address
          ? this.email_address
          : JSON.parse(sessionStorage.getItem('userObj')).emailId,
        phoneNo: sessionStorage.getItem('userObj')
          ? JSON.parse(sessionStorage.getItem('userObj')).phone
          : sessionStorage.getItem('userphone'),
        language: 'ENGLISH',
        dob: this.dob,
        authorizedRep: this.represnt,
      },
      invoiceType: this.invoice,
      promoDetails: {
        hearusOption: 'Google',
        promoeCode: 'HONESTGORILLA',
      },

      privateDetails: {
        state: this.state,
        license: this.license,
      },
      billingAddress: JSON.parse(sessionStorage.getItem('billingAddress')),
      isExpired: false,
      expirationDate: null,
      ReceivedPromocode: sessionStorage.getItem('Promocode'),
      UsedPromocode:
        sessionStorage.getItem('Promocode') === 'TAP' ? 'TAP' : 'HONESTGORILLA',
    };

    {
      // If ssn check pass allow to enroll
      // console.log.log('path name' + hg_accountId + this.recommendationService.signupProduct);
      // console.log.log('this.recommendationService.signupProduct:::::::::' + this.recommendationService.signupProduct);

      if (
        this.esiid_value != undefined &&
        this.esiid_value != 'ESI ID # Locator  Currently Unavailable'
      ) {
        localStorage.setItem('currentEsiid', this.esiid_value);
        orderDetails['esiid'] = this.esiid_value;
      } else if (this.esiid_value == null || this.esiid_value == '') {
        this.esiid_value = localStorage.getItem('currentEsiid');
        if (this.esiid_value != 'ESI ID # Locator  Currently Unavailable') {
          orderDetails['esiid'] = this.esiid_value;
        } else if (
          this.esiid_value === 'ESI ID # Locator  Currently Unavailable'
        ) {
          this.esiid_value = localStorage.getItem('otherEsiid');
          orderDetails['esiid'] = this.esiid_value;
        }
      } else {
        if (
          localStorage.getItem('currentEsiid') ===
          'ESI ID # Locator  Currently Unavailable'
        ) {
          this.esiid_value = localStorage.getItem('otherEsiid');
          orderDetails['esiid'] = this.esiid_value;
        } else {
          this.esiid_value = localStorage.getItem('currentEsiid');
          orderDetails['esiid'] = this.esiid_value;
        }
      }
      console.log(
        "orderDetails['esiid'] = this.esiid_value;.....",
        orderDetails['esiid']
      );
      // To check the selectedProduct in the service
      if (_.isEmpty(this.recommendationService.signupProduct)) {
        // get the selected product from session storage
        this.recommendationService.signupProduct = JSON.parse(
          sessionStorage.getItem('signupProduct')
        );
      }
      orderDetails['selectedProduct'] =
        this.recommendationService.signupProduct;
      if (startDate != 'Priority Move-In' && startDate != 'Standard Switch') {
        // calculation for the expiration date
        const expiredDate = new Date(startDate);
        let term = this.recommendationService.signupProduct.terms;
        expiredDate.setMonth(expiredDate.getMonth() + parseInt(term));
        var d = new Date(expiredDate);
        var dformat =
          [d.getMonth() + 1, d.getDate(), d.getFullYear()].join('/') +
          ' ' +
          [d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds()].join(':');
        orderDetails.expirationDate = dformat;
        console.log('expiedDate:::::' + dformat);
      } else {
        const expiredDate = new Date();
        let term = this.recommendationService.signupProduct.terms;
        expiredDate.setMonth(expiredDate.getMonth() + parseInt(term));
        var d = new Date(expiredDate);
        dformat =
          [d.getMonth() + 1, d.getDate(), d.getFullYear()].join('/') +
          ' ' +
          [d.getHours(), d.getMinutes(), d.getSeconds()].join(':');
        console.log(dformat);
        orderDetails.expirationDate = dformat;
      }
      if (_.isEmpty(this.residentialService['user'])) {
        this.residentialService['user'] = {
          accountId: '',
        };
        this.residentialService['user']['accountId'] = hg_accountId;
        this.residentialService.questionnaireStatusObj = JSON.parse(
          sessionStorage.getItem('questionStatusObj')
        );
      }
      this.residentialService.esiid = this.esiid_value;
      this.residentialService['user']['accountId'] = hg_accountId;
      // to variate the update of res question if it is from enrollment update
      if (this.residentialService.questionFlowType === 'renewal') {
        this.residentialService.processType = 'enrollment_renewal';
      }
      orderDetails.billingAddress = JSON.parse(
        sessionStorage.getItem('billingAddress')
      );

      let isGetOrderRes = false;
      let isNotificationRes = false;

      const body = new HttpParams().append(
        'orderDetails',
        JSON.stringify(orderDetails)
      );
      this.http.post(this.url + '/saveorders', body).subscribe((res: any) => {
        const result = res;
        isGetOrderRes = true;
        if (result.statusCode === '002') {
        } else {
          this.enrollNotifyObj = this.userSettingsService.enrollNotificationObj;
          if (
            this.enrollNotifyObj &&
            (this.enrollNotifyObj.type === 'enrollment_not_completed' ||
              this.enrollNotifyObj.type === 'renewal')
          ) {
            this.queryObj._id = this.enrollNotifyObj._id;
            this.updateObj['esiid'] = this.enrollNotifyObj.esiid;
            this.queryObj.hg_accountId = this.enrollNotifyObj.hg_accountId;
            this.queryObj.hg_orders_id = this.enrollNotifyObj.hg_orders_id;
            this.updateObj['processCompleted'] = true;
            if (this.enrollNotifyObj.showNotification === true) {
              this.updateObj['showNotification'] = false;
            }
            const enrollbody = new HttpParams()
              .append('queryObj', JSON.stringify(this.queryObj))
              .append('updateObj', JSON.stringify(this.updateObj));
          }
        }
      });
      if (
        webStatus === 'COMPLETE_SATISFIED' ||
        creditCheckResults === 'OPENED_WITH_NO_DEPOSIT'
      ) {
        // To send an congrats email
        const body1 = new HttpParams()
          .append('userDetails', JSON.stringify(userObj))
          .append('providerContact', JSON.stringify(this.providerContact));
        this.http
          .post(this.url + '/congratsEmail', body1)
          .subscribe((res: any) => {
            this.spinner.hide();
            const result = res;
          });
      } else if (
        postresult['Status'] === 'Enrollment has been completed' ||
        postresult['Status'] ===
          'Enrollment has been completed with Pending Status'
      ) {
        const userObj = {
          hg_accountId: window.location.href.split('/').pop(),
          esiid: localStorage.getItem('currentEsiid'),
          emailId: JSON.parse(sessionStorage.getItem('userObj')).emailId,
          enableMessage: '',
          referenumber: postresult['RefrenceNumber'],
        };

        const body11 = new HttpParams()
          .append('userDetails', JSON.stringify(userObj))
          .append('providerContact', JSON.stringify(this.providerContact));

        this.http
          .post(this.url + '/congratsEmail', body11)
          .subscribe((res: any) => {
            this.spinner.hide();
          });
      }
    }
  }

  serviceTypeExpireDate(startDate) {
    let term = this.recommendationService.signupProduct.terms,
      expiredDate =
        startDate !== 'Priority Move-In' && startDate !== 'Standard Switch'
          ? new Date(startDate)
          : new Date();
    expiredDate.setMonth(expiredDate.getMonth() + parseInt(term));
    var d = new Date(expiredDate);
    return (
      [d.getMonth() + 1, d.getDate(), d.getFullYear()].join('/') +
      ' ' +
      [d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds()].join(':')
    );
  }
  // Next button disable
  nooption() {
    const noThankyou = <HTMLInputElement>document.getElementById('NoThkyou');
    const yesIntrst = <HTMLInputElement>document.getElementById('YesInterest');
    if (
      (noThankyou.checked === true || yesIntrst.checked === true) &&
      !_.isEmpty(this.residentialService.enrollmentPostResult)
    ) {
      this.ngClass = true;
      this.disableBtn = false;
    } else {
      this.ngClass = false;
      this.disableBtn = true;
    }
  }

  nooption1() {
    const noThankyou = <HTMLInputElement>(
      document.getElementById('NoThkyou_mob')
    );
    const yesIntrst = <HTMLInputElement>(
      document.getElementById('YesInterest_mob')
    );
    if (
      (noThankyou.checked === true || yesIntrst.checked === true) &&
      !_.isEmpty(this.residentialService.enrollmentPostResult)
    ) {
      this.ngClass = true;
      this.disableBtn = false;
    } else {
      this.ngClass = false;
      this.disableBtn = true;
    }
  }

  getProviderInfo() {
    this.residentialService
      .getProviderContactInfoDetails(
        this.selectedProduct.energy_provider,
        this.selectedProduct.utility_name
      )
      .subscribe((res: any) => {
        this.providerContact = res[0];
      });
  }
}
